import {Component, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {DisinfectionprogramService} from '@services/disinfectionprogram.service';
import {LoaderService} from '@services/loader.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-disinfection',
    templateUrl: './add-disinfection.component.html',
    styleUrl: './add-disinfection.component.scss'
})
export class AddDisinfectionComponent implements OnInit {
    public disinfectionForm: FormGroup;
    public disinfectionlist: any[] = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public UserDetail: any;
    constructor(
        private fb: FormBuilder,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private disInfectionService: DisinfectionprogramService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.UserDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.isLoading$ = this.loaderService.isLoading$;
        this.disinfectionForm = this.fb.group({
            disinfectionProgramName: ['', Validators.required],
            disinfectionTypeId: ['', Validators.required],
            instructionsList: this.fb.array([this.createInstruction()]),
            userId: this.UserDetail.id,
            date: [new Date().toISOString()]
        });
        this.getDisInfectionTypeList();
    }

    // Method to create a new instruction form group
    createInstruction(): FormGroup {
        return this.fb.group({
            instructions: ['', Validators.required]
        });
    }

    // Add new instruction to the array
    addInstruction(): void {
        this.instructionsList.push(this.createInstruction());
    }

    // Remove an instruction from the array
    removeInstruction(index: number): void {
        this.instructionsList.removeAt(index);
    }

    // Get instructions as FormArray
    get instructionsList(): FormArray {
        return this.disinfectionForm.get('instructionsList') as FormArray;
    }

    getDisInfectionTypeList() {
        this.disInfectionService
            .getDisInfectionProgramList()
            .subscribe((result) => {
                this.disinfectionlist = result;
            });
    }
    // Submit the form
    onSubmit(): void {
        this.loaderService.showLoader();
        this.isAuthLoading = true;
        if (this.disinfectionForm.valid) {
            const formValue = this.disinfectionForm.value;
            this.disInfectionService.addDisInfection(formValue).subscribe({
                next: (response) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('DisInfection Added Successfully');
                    }, 2000);
                    this.router.navigate(['/disinfection-list']);
                },
                error: (error) => {
                    setTimeout(() => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        // Handle login error
                        this.toastr.error(error.error);
                    }, 2000);
                }
            });
        } else {
            this.loaderService.hideLoader();
            this.disinfectionForm.markAllAsTouched();
            this.isAuthLoading = false;
            this.toastr.error('Please fill the required fields');
        }
    }
    onClose(): void {
        this.router.navigate(['/disinfection-list']);
    }
}
